import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import Wait from "../../../../shared/assets/icons/waiting.svg";
import { useAppSelector } from "../../../../shared/store";

export const AwaitingRequisites = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  return (
    <OfferStatusInfo
      iconSrc={Wait}
      isRotate={true}
      title="Ищем реквизиты"
      description="Подождите, подбираем реквизиты для оплаты. Как только они появятся, вы автоматически увидите их здесь."
      buttonVariant="primary"
      link={offerData?.goodLink}
      isBtnVisible={!!offerData?.goodLink}
    />
  );
};
